import { render, staticRenderFns } from "./SelectCpfOrCnpjInput.vue?vue&type=template&id=0d3a5d7d&scoped=true&"
import script from "./SelectCpfOrCnpjInput.vue?vue&type=script&lang=js&"
export * from "./SelectCpfOrCnpjInput.vue?vue&type=script&lang=js&"
import style0 from "./SelectCpfOrCnpjInput.vue?vue&type=style&index=0&id=0d3a5d7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3a5d7d",
  null
  
)

export default component.exports